export const checkinEditDrawer = {
  header: {
    title: "Modifica i dati del check-in",
    age: "Età:",
    docNotRequiredMinor: "Documento non richiesto (minore)",
    docOptionalMinorES: "Documento facoltativo (minore in Spagna)",
    docOptionalMinorCO: "Documento facoltativo (sotto i 7 anni in Colombia)",
  },
  sections: {
    basicData: "Dati di base",
    stayDates: "Date del soggiorno",
    italyDoc: "Documento e Paese di nascita",
    doc: "Documento e nazionalità",
  },
  fields: {
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    phone: "Telefono",
    birthDate: "Data di nascita",
    sex: "Sesso",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Tipo di documento",
    docNumber: "Numero del documento",
    supportNumber: "Numero di supporto",
    nationality: "Nazionalità",
  },
  placeholders: {
    select: "Seleziona",
    selectNationality: "Seleziona la nazionalità",
    searchCountry: "Cerca Paese...",
    selectCountry: "— seleziona Paese —",
    docNumberExample: "es. AB1234567",
    docNumberGeneric: "DNI / NIE / Passaporto",
    required: "Obbligatorio",
    optional: "Facoltativo",
  },
  sex: {
    male: "Maschio",
    female: "Femmina",
    preferNotToSay: "Preferisco non dichiararlo",
    other: "Altro",
  },
  italy: {
    badge: "Alloggiati Web",
    birthCountryLabel: "Paese di nascita",
    birthCountryHint: "— usato anche come cittadinanza",
    issuePlaceLabel: "Luogo di rilascio del documento",
    issuePlaceHint: "— Paese in cui è stato rilasciato il documento",
    alloggiatiCode: "Codice Alloggiati:",
    iso3Label: "ISO3:",
    minorNote:
      "Minore — tipo di documento, numero e luogo di rilascio vengono inviati vuoti ad Alloggiati Web (TABELLA 1).",
  },
  hints: {
    docOptional:
      "Documento facoltativo secondo la regola per età/Paese. Puoi comunque compilarlo.",
  },
  docTypes: {
    it: {
      IDENT: "Documento d'identità (IDENT)",
      IDELE: "Documento d'identità elettronico (IDELE)",
      PASOR: "Passaporto ordinario (PASOR)",
      PASSE: "Passaporto di servizio (PASSE)",
      PASDI: "Passaporto diplomatico (PASDI)",
      PATEN: "Patente di guida (PATEN)",
      PATNA: "Patente nautica (PATNA)",
      CIDIP: "Documento d'identità diplomatico (CIDIP)",
      RIFUG: "Documento di viaggio per rifugiati (RIFUG)",
    },
    co: {
      CC: "Documento di cittadinanza",
      CE: "Documento d'identità per stranieri",
      P: "Passaporto",
      PPT: "Permesso di protezione temporanea",
      PEP: "Permesso di residenza speciale",
      DE: "Documento straniero",
      CD: "Tessera diplomatica",
    },
    es: {
      ID: "DNI",
      IM: "NIE",
      P: "Passaporto",
      OTRO: "Altro",
    },
    generic: {
      ID: "Documento d'identità",
      P: "Passaporto",
      OTRO: "Altro",
    },
  },
  footer: {
    cancel: "Annulla",
    save: "Salva",
    saving: "Salvataggio...",
  },
  errors: {
    nameRequired: "Nome e cognome sono obbligatori.",
    emailInvalid: "Email non valida.",
    phoneRequired: "Il telefono è obbligatorio.",
    birthDateRequired: "La data di nascita è obbligatoria.",
    sexRequired: "Il sesso è obbligatorio.",
    stayDatesRequired: "Le date del soggiorno sono obbligatorie.",
    checkoutBeforeCheckin: "La data di check-out non può essere precedente a quella di check-in.",
    birthCountryRequired: "Il Paese di nascita è obbligatorio.",
    docTypeRequired: "Il tipo di documento è obbligatorio.",
    docNumberRequired: "Il numero del documento è obbligatorio.",
    issuePlaceRequired: "Il luogo di rilascio del documento è obbligatorio.",
    nationalityRequired: "La nazionalità è obbligatoria.",
    supportNumberRequired:
      "Il numero di supporto è obbligatorio per la nazionalità spagnola (adulto).",
    saveFailed: "Impossibile salvare.",
    saveError: "Errore durante il salvataggio delle modifiche.",
  },
  toast: {
    saved: "Check-in aggiornato con successo",
  },
};
